/**
 * AUTO-GENERATED FILE - DO NOT EDIT MANUALLY
 * Generated by: scripts/generate-template-loaders.js
 * Source files:
 *   - quotation.njk
 *   - quotation.css
 */

export const QUOTATION_TEMPLATE = `<div class="qt-card">
  <div
    class="a4-container">
    <!-- Header Row (50/50 Split) -->
    <div class="a4-hdr-row">
      <div class="a4-hdr-left">
        {% if logoUrl %}
          <img class="a4-hdr-logo-img" src="{{ logoUrl }}" alt="{{ storeName }}"/>
        {% endif %}
      </div>
      <div class="a4-hdr-right-store">
        <div class="store-title">{{ storeName }}</div>
        {% if address %}
          <p>{{ address | replace('\\n', ', ') }}</p>
        {% endif %}
        {% if phone %}
          <p>{{ phone }}
            {% if whatsapp %}
              / {{ whatsapp }}
            {% endif %}
          </p>
        {% endif %}
        {% if email %}
          <p>{{ email }}</p>
        {% endif %}
        {% if website %}
          <p>{{ website }}</p>
        {% endif %}
      </div>
    </div>
    <!-- Horizontal Metadata Row -->
    <div class="a4-meta-row">
      <div class="a4-meta-col">
        <span class="a4-meta-lbl">Quote No</span>
        <strong class="a4-meta-val">{{ refNo }}</strong>
      </div>
      <div class="a4-meta-col">
        <span class="a4-meta-lbl">Date</span>
        <strong class="a4-meta-val">{{ dateStr }}</strong>
      </div>
      <div class="a4-meta-col">
        <span class="a4-meta-lbl">Validity</span>
        <strong class="a4-meta-val">{{ validityDays }} Days</strong>
      </div>
      <div class="a4-meta-col text-right">
        <span class="a4-meta-lbl">Status</span>
        <span class="status-badge-a4 active" style="font-weight: bold;">ACTIVE</span>
      </div>
    </div>
    <!-- Re/Subject line if quotationName is present -->
    {% if quotationName and not quotationName.startsWith('Quotation #') %}
      <div style="background: #f8fafc; border-left: 4px solid #475569; padding: 8px 15px; margin-bottom: 15px; font-size: 0.95em;">
        <strong style="color: #64748b; font-size: 0.85em; text-transform: uppercase; margin-right: 8px;">Subject:</strong>
        <span style="font-weight: 600; color: #1e293b;">{{ quotationName }}</span>
      </div>
    {% endif %}
    <!-- Customer Cards Info -->
    <div class="a4-cust-card">
      <div class="a4-cust-grid">
        <span class="a4-cust-lbl">Customer Name:</span>
        <span class="a4-cust-val">{{ customerName }}</span>
        {% if customerAddress %}
          <span class="a4-cust-lbl">Address:</span>
          <span class="a4-cust-val">{{ customerAddress }}</span>
        {% endif %}
        {% if customerPhone %}
          <span class="a4-cust-lbl">Contact:</span>
          <span class="a4-cust-val">{{ customerPhone }}</span>
        {% endif %}
        {% if customerEmail %}
          <span class="a4-cust-lbl">Email:</span>
          <span class="a4-cust-val" style="text-transform: none;">{{ customerEmail }}</span>
        {% endif %}
        {% if vehicleNo %}
          <span class="a4-cust-lbl">Vehicle No:</span>
          <span class="a4-cust-val">{{ vehicleNo }}</span>
        {% endif %}
      </div>
    </div>
    <!-- Items Table -->
    <table class="a4-items-table">
      <thead>
        <tr>
          <th class="a4-col-no">NO</th>
          <th class="a4-col-desc">ITEM DESCRIPTION</th>
          <th class="a4-col-price">PRICE</th>
          <th class="a4-col-qty">QUANTITY</th>
          <th class="a4-col-amount">AMOUNT</th>
        </tr>
      </thead>
      <tbody>
        {% for item in items %}
          <tr class="a4-item-row">
            <td class="a4-col-no">{{ loop.index }}</td>
            <td class="a4-desc-cell">
              {{ item.name }}
              {% if item.variant_name %}
                <span style="display:block;font-size:0.85em;color:#4a5568;">({{ item.variant_name }})</span>
              {% endif %}
              {% if item.batch_no %}
                <small>Batch: ({{ item.batch_no }})</small>
              {% endif %}
              {% set itemNote = item.description or item.note or item.notes or item.special_note %}
              {% if itemNote %}
                <div style="font-size:0.82em;color:#555;font-style:italic;margin-top:2px;">Note: {{ itemNote }}</div>
              {% endif %}
            </td>
            <td class="a4-price-cell">{{ item.price | formatPrice }}</td>
            <td class="a4-qty-cell">{{ item.qty }}</td>
            <td class="a4-amount-cell">{{ (item.price * item.qty) | formatPrice }}</td>
          </tr>
        {% endfor %}
      </tbody>
    </table>
    <!-- Modern Summary Section -->
    <div class="a4-summary-container">
      <div class="a4-summary-left-card">
        <div class="a4-info-row">
          <span class="a4-info-label">Total Items Count</span>
          <span class="a4-info-value">{{ items.length }} Item(s)</span>
        </div>
        <div class="a4-info-row">
          <span class="a4-info-label">Quote Validity</span>
          <span class="a4-info-value payment-badge">{{ validityDays }} Days</span>
        </div>
        <div class="a4-info-row">
          <span class="a4-info-label">Status</span>
          <span class="a4-info-value status-badge-a4 active">ACTIVE</span>
        </div>
      </div>
      <div class="a4-summary-right-totals">
        <div class="a4-total-row">
          <span class="a4-total-lbl">Sub Total</span>
          <span class="a4-total-val">{{ subtotal | formatPrice }}</span>
        </div>
        <div class="a4-grand-total-row">
          <span class="a4-grand-lbl">GRAND TOTAL</span>
          <span class="a4-grand-val">{{ currency }}
            {{ subtotal | formatPrice }}</span>
        </div>
      </div>
    </div>
    <!-- Signature Section -->
    <div class="a4-signature-section">
      <div class="a4-sig-block">
        <div class="a4-sig-line"></div>
        <div class="a4-sig-label">Prepared By</div>
      </div>
      <div class="a4-sig-block">
        <div class="a4-sig-line"></div>
        <div class="a4-sig-label">Accepted By (Customer Signature)</div>
      </div>
    </div>
    <!-- Bottom Footer -->
    <div class="a4-ftr">
      <div class="a4-ftr-thank">Thank you for business, Visit us again!</div>
      <div class="a4-ftr-powered">Powered by {{ webName }}</div>
    </div>
  </div>
</div>`;

export const QUOTATION_CSS = `@import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap");

*,
*::before,
*::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  font-family: Arial, Helvetica, sans-serif;
  font-size: var(--qt-font, 13.5px);
  color: #000;
  background: var(--qt-bg, #edf2f7);
  padding: var(--qt-body-pad, 28px 20px);
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
}

.a4-container {
  display: flex;
  flex-direction: column;
  color: #000;
  background: #fff;
  width: 100%;
}

.qt-card {
  width: var(--qt-width, 210mm);
  max-width: 100%;
  margin: 0 auto;
  background: #ffffff;
  border-radius: var(--qt-radius, 6px);
  padding: 40px;
  box-shadow: var(--qt-shadow, 0 4px 24px rgba(67, 56, 202, 0.1));
  border: var(--qt-card-border, 1px solid #cbd5e1);
}

.a4-hdr-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.a4-hdr-left {
  width: 50%;
  flex: 0 0 50%;
}

.a4-hdr-logo-img {
  max-height: 80px;
  max-width: 100%;
  object-fit: contain;
}

.a4-hdr-right-store {
  width: 50%;
  flex: 0 0 50%;
  text-align: right;
}

.a4-hdr-right-store .store-title {
  font-size: 1.5em;
  font-weight: 700;
  text-transform: uppercase;
  margin-bottom: 4px;
}

.a4-hdr-right-store p {
  font-size: 0.9em;
  margin: 2px 0;
  color: #333;
}

.a4-meta-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1.5px solid #000;
  border-bottom: 1.5px solid #000;
  padding: 8px 10px;
  margin-bottom: 20px;
  background-color: #f8f9fa;
  font-size: 0.9em;
}

.a4-meta-col {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.a4-meta-col.text-right {
  align-items: flex-end;
}

.a4-meta-lbl {
  font-size: 0.78em;
  text-transform: uppercase;
  color: #555;
  letter-spacing: 0.5px;
}

.a4-meta-val {
  font-size: 0.95em;
  color: #000;
}

.a4-cust-card {
  margin: 10px 0 20px 0;
  font-size: 0.95em;
}

.a4-cust-grid {
  display: grid;
  grid-template-columns: 140px 1fr;
  gap: 4px 10px;
}

.a4-cust-lbl {
  font-weight: 500;
  color: #333;
}

.a4-cust-val {
  font-weight: 700;
  text-transform: uppercase;
}

.a4-items-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  font-size: 0.95em;
}

.a4-items-table th,
.a4-items-table td {
  border: 1px solid #888;
  padding: 8px 10px;
}

.a4-items-table th {
  background-color: #f2f2f2;
  font-weight: 700;
  text-transform: uppercase;
}

.a4-col-no {
  width: 6%;
  text-align: center;
}
.a4-col-desc {
  width: 54%;
  text-align: left;
}
.a4-col-price {
  width: 14%;
  text-align: right;
}
.a4-col-qty {
  width: 10%;
  text-align: center;
}
.a4-col-amount {
  width: 16%;
  text-align: right;
}

.a4-item-row td {
  vertical-align: middle;
}

.a4-item-row .a4-desc-cell {
  text-align: left;
}

.a4-item-row .a4-price-cell {
  text-align: right;
}

.a4-item-row .a4-qty-cell {
  text-align: center;
}

.a4-item-row .a4-amount-cell {
  text-align: right;
  font-weight: 500;
}

.a4-item-disc-row td {
  padding: 4px 10px;
  font-size: 0.88em;
  background-color: #fafafa;
}

.a4-item-disc-label {
  text-align: right;
  font-style: italic;
}

.a4-item-disc-val {
  text-align: right;
  font-style: italic;
}

/* Summary Section */
.a4-summary-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 20px;
  gap: 30px;
}

.a4-summary-left-card {
  width: 45%;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #dee2e6;
  padding: 15px;
}

.a4-info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e9ecef;
  padding-bottom: 8px;
  margin-bottom: 8px;
}

.a4-info-row:last-child {
  border-bottom: none;
  padding-bottom: 0;
  margin-bottom: 0;
}

.a4-info-label {
  color: #495057;
  font-weight: 500;
  font-size: 0.9em;
}

.a4-info-value {
  font-weight: 700;
  color: #212529;
  font-size: 0.9em;
}

.payment-badge {
  text-transform: uppercase;
  background-color: #e9ecef;
  padding: 2px 8px;
  border-radius: 4px;
}

.status-badge-a4 {
  padding: 3px 10px;
  border-radius: 12px;
  font-weight: 700;
  font-size: 0.85em;
  text-transform: uppercase;
}

.status-badge-a4.completed,
.status-badge-a4.active {
  background-color: #d4edda;
  color: #155724;
}

.a4-summary-right-totals {
  width: 45%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  text-align: right;
}

.a4-total-row {
  display: flex;
  justify-content: space-between;
  font-size: 0.95em;
  color: #495057;
}

.a4-grand-total-row {
  display: flex;
  justify-content: space-between;
  border-top: 2px solid #212529;
  padding-top: 10px;
  margin-top: 5px;
}

.a4-grand-lbl {
  font-weight: 700;
  font-size: 1.15em;
  color: #212529;
}

.a4-grand-val {
  font-weight: 700;
  font-size: 1.15em;
  color: #212529;
}

.a4-signature-section {
  display: flex;
  justify-content: space-between;
  margin-top: 60px;
  margin-bottom: 20px;
  padding: 0 15px;
}

.a4-sig-block {
  width: 220px;
  text-align: center;
}

.a4-sig-line {
  border-top: 1px solid #333;
  margin-bottom: 6px;
}

.a4-sig-label {
  font-size: 0.85em;
  font-weight: 600;
  color: #495057;
}

.a4-ftr {
  text-align: center;
  margin-top: 40px;
  font-size: 0.9em;
  line-height: 1.5;
}

.a4-ftr-note {
  font-style: italic;
  margin-bottom: 6px;
}

.a4-ftr-thank {
  font-weight: 700;
  font-size: 1.05em;
}

.a4-ftr-powered {
  margin-top: 8px;
  font-size: 0.8em;
  color: #777;
}

@media print {
  body {
    background: #fff;
    padding: 0;
  }
  .qt-card {
    box-shadow: none;
    border: none;
    border-radius: 0;
    width: 100% !important;
    padding: 0;
  }
  @page {
    size: var(--qt-page-size, A4);
    margin: 10mm;
  }
}
`;
